import { useState, useEffect } from 'react';
import API, { fmt } from '@/lib/api';
import { Plus, Trash, X } from '@phosphor-icons/react';

export default function VoorraadPage() {
  const [voorraad, setVoorraad] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ naam: '', cat: '', stock: '', ap: '', min: '', max: '' });
  const [q, setQ] = useState('');

  const load = () => API.get('/voorraad').then(r => setVoorraad(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const u = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    if (!form.naam) { alert('Vul productnaam in'); return; }
    const data = { ...form, stock: parseInt(form.stock) || 0, ap: parseFloat(form.ap) || 0, min: parseInt(form.min) || 0, max: parseInt(form.max) || 0 };
    await API.post('/voorraad', data);
    setForm({ naam: '', cat: '', stock: '', ap: '', min: '', max: '' });
    setShowForm(false);
    load();
  };

  const del = async (id) => {
    if (!window.confirm('Voorraaditem verwijderen?')) return;
    await API.delete(`/voorraad/${id}`);
    load();
  };

  const filtered = voorraad.filter(v => !q || v.naam.toLowerCase().includes(q.toLowerCase()));
  const kritiek = filtered.filter(v => v.stock <= v.min * 0.5);
  const laag = filtered.filter(v => v.stock > v.min * 0.5 && v.stock <= v.min);
  const ok = filtered.filter(v => v.stock > v.min);

  return (
    <div data-testid="voorraad-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="page-heading mb-0">Voorraad</h1>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)} data-testid="toggle-voorraad-form">
          {showForm ? <><X size={14} /> Sluiten</> : <><Plus size={14} weight="bold" /> Nieuw item</>}
        </button>
      </div>

      {showForm && (
        <div className="inline-form" data-testid="voorraad-form">
          <div className="form-grid">
            <div className="form-group"><label className="form-label">Productnaam</label><input className="field-input" value={form.naam} onChange={u('naam')} placeholder="Laptop Pro" data-testid="voorraad-naam" /></div>
            <div className="form-group"><label className="form-label">Categorie</label><input className="field-input" value={form.cat} onChange={u('cat')} placeholder="Hardware" data-testid="voorraad-cat" /></div>
            <div className="form-group"><label className="form-label">Voorraad</label><input type="number" className="field-input" value={form.stock} onChange={u('stock')} placeholder="10" data-testid="voorraad-stock" /></div>
            <div className="form-group"><label className="form-label">Aankoopprijs</label><input type="number" className="field-input" value={form.ap} step="0.01" onChange={u('ap')} placeholder="850.00" data-testid="voorraad-ap" /></div>
            <div className="form-group"><label className="form-label">Min. voorraad</label><input type="number" className="field-input" value={form.min} onChange={u('min')} placeholder="5" data-testid="voorraad-min" /></div>
            <div className="form-group"><label className="form-label">Max. voorraad</label><input type="number" className="field-input" value={form.max} onChange={u('max')} placeholder="20" data-testid="voorraad-max" /></div>
          </div>
          <div className="flex gap-2 justify-end mt-3">
            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>Annuleren</button>
            <button className="btn btn-primary" onClick={save} data-testid="save-voorraad-btn">Opslaan</button>
          </div>
        </div>
      )}

      <div className="mb-4">
        <input className="field-input" style={{ maxWidth: 250 }} placeholder="Zoeken..." value={q} onChange={e => setQ(e.target.value)} data-testid="voorraad-search" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div className="kpi-card"><div className="kpi-label">Kritiek</div><div className="kpi-value text-[#E02424]">{kritiek.length}</div></div>
        <div className="kpi-card"><div className="kpi-label">Laag</div><div className="kpi-value text-[#E5B300]">{laag.length}</div></div>
        <div className="kpi-card"><div className="kpi-label">OK</div><div className="kpi-value text-[#008A27]">{ok.length}</div></div>
      </div>

      <div className="section-card">
        <div className="section-body">
          <table className="data-table">
            <thead><tr><th>Product</th><th>Categorie</th><th className="right">Voorraad</th><th className="right">Min</th><th className="right">Max</th><th className="right">Waarde</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {filtered.map(v => {
                const status = v.stock <= v.min * 0.5 ? 'kritiek' : v.stock <= v.min ? 'laag' : 'ok';
                const badgeClass = status === 'kritiek' ? 'badge-red' : status === 'laag' ? 'badge-yellow' : 'badge-green';
                return (
                  <tr key={v.id}>
                    <td className="font-medium">{v.naam}</td>
                    <td>{v.cat || '-'}</td>
                    <td className="right font-bold">{v.stock}</td>
                    <td className="right">{v.min}</td>
                    <td className="right">{v.max}</td>
                    <td className="right">{fmt(v.stock * v.ap)}</td>
                    <td><span className={`badge ${badgeClass}`}>{status}</span></td>
                    <td><button className="btn btn-danger btn-sm" onClick={() => del(v.id)} data-testid={`del-voorraad-${v.id}`}><Trash size={14} /></button></td>
                  </tr>
                );
              })}
              {filtered.length === 0 && <tr><td colSpan="8" className="text-center text-gray-400 py-8">Geen voorraad</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
